import { useEffect, useRef, useState } from "react";
import { Logo, NavIcon } from "../graphics/icons";

export const NavBar = () => {
  const ref = useRef(null);

  const [scroll, didScroll] = useState(0);

  useEffect(() => {
    if (!ref) return;
    const handleScroll = () => {
      const scrolled = window.scrollY;

      if (scroll > scrolled) {
        console.log("ScrollUP");
        didScroll(scrolled);
        ref.current.classList.add("reveal");
      } else {
        didScroll(scrolled);
        console.log("ScrollDOWN");
        ref.current.classList.remove("reveal");
      }
    };

    // Add event listener to the window
    window.addEventListener("scroll", handleScroll);

    // Remove event listener when the component is unmounted
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scroll]);
  return (
    <nav ref={ref} className="reveal">
      <div className="menu-wrapper">
        <Logo />
        <NavIcon />
        <div className="menu">
          <a href="/#what">What we do</a>
          <a href="/#about">About us</a>
          <a href="/#how">The HX effect</a>
          <a href="/#contact">Contact us</a>
          <a href="/privacy">Privacy Policy</a>
        </div>
      </div>
    </nav>
  );
};
